import { Div, Label, not } from 'alkali'
import { STUDY_LEVEL_GRP } from 'services/extract/types'
import * as deleteIcon from 'icons/delete-1.svg'
import Icon from 'components/Icon'
import { TextAreaFieldControl } from 'components/extract/Inputs'
import { notEmpty, validateFn, validationCtx } from 'components/extract/model/validation'

class NoteComponent extends Div('.note-component') {
	created(props) {
		const cell = props.cell
		const row = props.row
		const rows = props.rows
		props.content = [
			Div('.note-label', Label('Note:')),
			Div('.note-cell', [
				TextAreaFieldControl('.row-def-input', {
					//inputEvents: _.without(TEXT_INPUT_CHANGE_EVENTS, 'keyup', 'click', 'input'),
					value: cell.property('val'),
					optional: true,
					validation: cell.to(validationCtx('Note', validateFn(cell => cell.id || notEmpty(cell.val), 'Note must not be empty', true)))
				})
			]),
			Div('.note-op', [
				Icon('.clickable', {
					title: 'Remove note',
					icon: deleteIcon,
					classes: {
						// hide delete for existing data, since we don't have an explicit delete per se
						invisible: cell.property('existing')
					},
					onclick() {
						rows.splice(rows.indexOf(row), 1)
					}
				})
			])
		]
	}
}

export default class NoteRow extends Div('.note-row') {
	created(props) {
		const row = props.row
		const rows = props.rows
		const cell = row.cells.property(STUDY_LEVEL_GRP)
		props.content = [
			new NoteComponent({ rows, row, cell })
		]
	}
}